import { UsersRepo } from "../users.repo";
import { newUser } from "./newUser";

class AddUserDetailsController implements angular.IOnInit {
  public user: newUser;
  public isLoading: boolean = false;

  /** @ngInject */
  constructor(private usersRepo: UsersRepo, private $state: angular.ui.IStateService, private $stateParams: angular.ui.IStateParamsService) { }

  $onInit(): void {
    this.user = <newUser>{
      sendInvite: false,
      roles: []
    };
    if (this.$stateParams.user) {
      this.user = this.$stateParams.user;
    }
  }

  public saveUser() {
    this.isLoading = true;
    this.usersRepo.saveUser(this.user)
      .then(user => {
        this.user.id = user.id;
        this.$state.go(`.clients`, { id: this.user.id, user: this.user })
      })
      .finally(() => this.isLoading = false);
  }

  public cancel() {
    this.$state.go('^');
  }
}

export const addUserDetails: angular.IComponentOptions = {
  controller: AddUserDetailsController,
  template: require('./addUserDetails.html')
}



// WEBPACK FOOTER //
// ./src/app/users/newUser/addUserDetails.ts